import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
    getBlooddonations,
    deleteBlooddonation,
    getNextBlooddonations,
    getPreviousBlooddonations,
} from "../../store/actions/blooddonations_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/blooddonations_enum";
import DataTable from "../../components/common/DataTable";
const AllBlooddonations = ({
    getBlooddonations,
    deleteBlooddonation,
    getNextBlooddonations,
    getPreviousBlooddonations,
    blooddonation: { loading, blooddonations },
}) => {
    const [page, setPage] = useState(1);
    const [deleteEntry, setDeleteEntry] = useState(null);
    const [q, setQ] = useState(null);
    const [term, setTerm] = useState(null);
    const [termField, setTermField] = useState(SEARCH_TERMS[0]);
    useEffect(() => {
        async function allQuery() {
            if (deleteEntry) {
                await deleteBlooddonation(deleteEntry);
            }
            getBlooddonations({});
        }
        allQuery();
    }, [deleteEntry]);

    const nextButtonClicked = () => {
        if (blooddonations && blooddonations.length === LIMIT) {
            const lastBlooddonation = blooddonations[blooddonations.length - 1];
            getNextBlooddonations({ last: lastBlooddonation });
            setPage(page + 1);
        }
    };
    const prevBtnClicked = () => {
        if (page > 1) {
            const lastBlooddonation = blooddonations[0];
            getPreviousBlooddonations({
                first: lastBlooddonation,
            });
            setPage(page - 1);
        }
    };
    const filterClicked = () => {
        if (term && term.length > 0) {
            setPage(1);
            setQ(term);
            getBlooddonations({ term: term, termField: termField });
        }
    };
    const deleteBlooddonationClicked = (id) => {
        setDeleteEntry(id);
    };
    const resetFilter = () => {
        setPage(1);
        setQ(null);
        setTerm("");
        getBlooddonations({});
    };

    return (
        <div className="pace-done">
            <div>
                <Header />
                <BreadCrumb
                    title="Blooddonations"
                    mainLinkTitle="Dashboard"
                    mainLinkUrl="/dashboard"
                    activeLink="Blooddonation"
                />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="card"
                                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
                            >
                                <div className="card-body">
                                    <AddBtn item="blooddonations" title="Blooddonation" />
                                    <hr />

                                    <Filters
                                        q={q}
                                        resetFilter={resetFilter}
                                        setTerm={setTerm}
                                        term={term}
                                        filterClicked={filterClicked}
                                        termField={termField}
                                        setTermField={setTermField}
                                        all_terms={SEARCH_TERMS}
                                    />
                                    <hr />
                                    <div>
                                        <DataTable
                                            keys={view_all_table}
                                            data={blooddonations}
                                            field={"blooddonations"}
                                            page={page}
                                            deleteBtnClicked={deleteBlooddonationClicked}
                                            loading={loading}
                                        />
                                        <Pagination
                                            data={blooddonations}
                                            page={page}
                                            prevBtnClicked={prevBtnClicked}
                                            nextButtonClicked={nextButtonClicked}
                                            loading={loading}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({ blooddonation: state.blooddonation });

const mapDispatchToProps = {
    getBlooddonations,
    deleteBlooddonation,
    getNextBlooddonations,
    getPreviousBlooddonations,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllBlooddonations);
